package dev.lingvo.site.ds

/** A move uses the live list's indexes so callers can persist a complete permutation. */
data class ReorderMove(val from: Int, val to: Int)

/** Keeps cancellation reversible even after several keyboard moves have been previewed. */
data class ReorderState(val origin: Int? = null, val position: Int? = null)

/** Separates keyboard intent from DOM focus and persistence. */
data class ReorderResult(val state: ReorderState, val move: ReorderMove? = null, val handled: Boolean = false)

/** Resolves bounded moves; Escape moves the picked-up item back to its original position. */
fun reorderKey(state: ReorderState, index: Int, count: Int, key: String, alt: Boolean = false): ReorderResult {
    if (count <= 0 || index !in 0 until count) return ReorderResult(ReorderState())
    if (state.position != null && (state.position !in 0 until count || state.origin == null || state.origin !in 0 until count)) return ReorderResult(ReorderState())
    val position = state.position ?: index
    if (key == "Escape" && state.origin != null) return ReorderResult(
        ReorderState(), ReorderMove(position, state.origin).takeIf { it.from != it.to }, true,
    )
    if (key == " " && !alt) return ReorderResult(
        if (state.origin == null) ReorderState(index, index) else ReorderState(), handled = true,
    )
    val delta = when (key) { "ArrowUp" -> -1; "ArrowDown" -> 1; else -> return ReorderResult(state) }
    if (!alt && state.origin == null) return ReorderResult(state)
    val target = (position + delta).coerceIn(0, count - 1)
    return ReorderResult(
        if (state.origin != null) state.copy(position = target) else state,
        ReorderMove(position, target).takeIf { it.from != it.to }, true,
    )
}
